module.exports = __webpack_public_path__ + "img/Rectangle_22.c140452b.png";